import axios from 'axios';

const getParagraphs = (statements) => {
  return axios.get(`${process.env.NEXT_PUBLIC_GRAPPLE_BACKEND_URL}statements?${statements}`, {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
  });
};

export default getParagraphs;
